import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";

const PhoneNotificationComponent = () => {
  const { workerUser } = useOutletContext();
  const [mobileNumber, setMobileNumber] = useState(
    workerUser?.mobileNumber || ""
  );
  const [receiveSMS, setReceiveSMS] = useState(false);

  useEffect(() => {
    if (workerUser) {
      setMobileNumber(workerUser.mobileNumber || "");
    }
  }, [workerUser]);

  return (
    <div className="notifications-account-settings">
      <h3>Set Up Phone Notifications</h3>
      <label htmlFor="phoneNumber">Phone Number</label>
      <input
        type="tel"
        id="mobileNumber"
        value={mobileNumber}
        onChange={(e) => setMobileNumber(e.target.value)}
      />

      <div className="phnnotfctsttngs-checkbox-container">
        <label className="phnnotfctsttngs-checkbox-label">
          <input
            type="checkbox"
            checked={receiveSMS}
            onChange={() => setReceiveSMS(!receiveSMS)}
          />
          Receive SMS when notifications are sent
        </label>
      </div>

      <button className="notifications-save-button">Save Changes</button>
    </div>
  );
};

export default PhoneNotificationComponent;
